import React from 'react';
import Chip from '@material-ui/core/Chip';


const CATEGORY_CONFIG = {
  table: { label: 'Table', color: '#2563EB', bgColor: '#EFF6FF' },
  view: { label: 'View', color: '#10B981', bgColor: '#ECFDF5' },
  procedure: { label: 'Stored Proc', color: '#8B5CF6', bgColor: '#F5F3FF' },
  function: { label: 'Function', color: '#F59E0B', bgColor: '#FEF3C7' }
};

const getCategoryInfo = (type) => {
  const typeLower = (type || '').toLowerCase();
  for (const [key, config] of Object.entries(CATEGORY_CONFIG)) {
    if (typeLower.includes(key)) {
      return config;
    }
  }
  return { label: type || 'Unknown', color: '#6b7280', bgColor: '#f3f4f6' };
};

const ObjectTable = ({ objects, onRowClick, selectedObject }) => {
  return (
    <div>
    <div className="object-table-container">
      <table className="object-table" data-testid="dd-list">
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Source Name</th>
            <th>Business Context</th>
          </tr>
        </thead>
        <tbody>
          {objects.map((obj, index) => {
            const categoryInfo = getCategoryInfo(obj.type || obj.objectType);
            const objId = obj.objectId || obj.id;
            const selectedId = selectedObject ? (selectedObject.objectId || selectedObject.id) : null;
            const isSelected = selectedObject && objId && objId === selectedId;
            
            return (
              <tr key={obj.id || index} data-testid="dd-row" className={`object-row ${isSelected ? 'selected' : ''}`}>
                <td className="object-name">
                  <a href="#" onClick={(e) => { e.preventDefault(); onRowClick(obj); }}>
                    {obj.displayName}
                  </a>
                </td>
                <td>
                  <Chip
                    label={categoryInfo.label}
                    size="small"
                    style={{
                      backgroundColor: categoryInfo.bgColor,
                      color: categoryInfo.color,
                      fontWeight: 500,
                      fontSize: '12px'
                    }}
                  />
                </td>
                <td className="object-source">
                  {obj.sourceName || '-'}
                </td>
                <td className="object-context">
                  {obj.businessContext || 'Not Available'}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
    </div>
  );
};

export default ObjectTable;
